import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';
import templateMarkup from 'raw-loader!./actions-modal.html';

    

    function ActionsModal(params) {
        var self = this;

        if (!_.has(params, 'signals.onActionSelected')) {
            throw new Error('ActionsModal:: Missing required signals: onActionSelected');
        }
        this.onActionSelectedSignal = params.signals.onActionSelected;

        params.enableSave(false);
        params.showSave(false);

        this.model = params.model;

        this.actions = [
            {
                action: 'updateDetails',
                displayName: 'Update Details'
            },
            {
                action: 'appendTags',
                displayName: 'Append Tags'
            },
        ];

        this.signals = params.signals;
        this.signalListeners = {
            onShow: this.show.bind(this)
        };
        this.signals.onShow.add(this.signalListeners.onShow);

        this.selectAction = function(actionObj) {
            self.onActionSelectedSignal.dispatch(actionObj.action, ko.unwrap(self.model));
        };
    }

    ActionsModal.prototype = {
        show: function (model) {
            this.model = model;
        },
        dispose: function () {
            this.signals.onShow.remove(this.signalListeners.onShow);
            delete this.signalListeners;
        }
    };

    export default { viewModel: ActionsModal, template: templateMarkup };

